module.exports = __webpack_public_path__ + "img/2.7c44c84f.png";